var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("My Snips")]),_c('SnipThumbnails',{attrs:{"snips":_vm.snips,"loading":_vm.loading}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }